<template>
  <section class="homepage-hero">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col homepage-hero__column">
          <p class="homepage-hero__copy">
            Your journey towards building a successful brand name starts here
          </p>

          <FormulateInput
            type="text"
            v-model="projectName"
            :outer-class="['homepage-hero__input-wrapper']"
            :wrapper-class="['formulate-input-wrapper--inline']"
            :element-class="[
              'formulate-input-element--inline',
              'formulate-input-element--inline-white',
              'homepage-hero__input-element',
            ]"
            ref="projectNameInput"
            @input="animationController"
          >
            <template #suffix>
              <button type="button" class="btn" @click="showPopup">
                ENTER
              </button>
            </template>
          </FormulateInput>
          <Popup
            v-if="showPopupFlag"
            style="z-index: 999"
            @close-popup="closePopup"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions } from "vuex";
import Popup from "./CookieBanner.vue";
export default {
  name: "HomeHero",
  components: {
    Popup,
  },
  data: function () {
    return {
      projectName: "",
      sentences: [
        "Funkwhack",
        "Snubbla",
        "Guazy",
        "Huggles",
        "Wagbag",
        "Dregskegs",
        "Cooltrain",
      ],
      currentSentence: 0,
      currentLetter: 0,
      typing: true,
      pause: 2000,
      loginstate: false,
      intervalID: "",
      showPopupFlag: false,
    };
  },
  mounted() {
    this.showPopupFlag = true;
    this.animateText();

    if (sessionStorage.getItem("_khonsu_user_login_status")) {
      this.loginstate = true;
    }

    document.addEventListener("click", this.handleOutsideClick);
  },

  beforeDestroy() {
    document.removeEventListener("click", this.handleOutsideClick);
  },

  methods: {
    ...mapActions("BrandCentre", ["setProjectName"]),
    save_brand_name() {
      this.setProjectName(this.projectName);
      this.projectName = "";

      if (this.loginstate) {
        this.$router.push("/brand-creator");
      } else {
        this.$router.push("/login");
      }
    },
    animateText() {
      let input = this.$refs.projectNameInput;
      input.$attrs.placeholder = "";

      this.intervalID = setInterval(() => {
        if (this.typing) {
          this.currentLetter++;

          if (
            this.currentLetter <= this.sentences[this.currentSentence].length
          ) {
            input.$attrs.placeholder =
              input.$attrs.placeholder +
              this.sentences[this.currentSentence][this.currentLetter - 1];
          } else {
            this.currentLetter = 0;
            this.typing = false;

            setTimeout(() => {
              this.currentSentence++;

              if (this.currentSentence >= this.sentences.length) {
                this.currentSentence = 0;
              }

              input.$attrs.placeholder = "";
              this.typing = true;
            }, this.pause);
          }
        }
      }, this.randDelay(50, 100));
    },
    randDelay(min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min);
    },
    animationController() {
      if (this.projectName.length > 0) {
        clearInterval(this.intervalID);
      } else {
        this.currentLetter = 0;
        this.typing = true;
        this.animateText();
      }
    },
    showPopup() {
      this.showPopupFlag = true;
    },
    closePopup() {
      this.showPopupFlag = false;
      sessionStorage.setItem("cookieBannerSeen", "true");
    },
    handleOutsideClick(event) {
      const popupElement = this.$refs.popup.$el;
      if (popupElement && !popupElement.contains(event.target)) {
        this.closePopup();
      }
    },
  },
};
</script>
